import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectionList, MatListOption } from '@angular/material/list';

@Component({
    selector: 'unite-origin-own-assets-input',
    templateUrl: './origin-own-assets-input.component.html',
    styleUrls: ['./origin-own-assets-input.component.scss'],
    imports: [MatSelectionList, ReactiveFormsModule, MatListOption, TranslateModule]
})
export class OriginOwnAssetsInputComponent {

  control = input<FormControl>();

}
